import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import { BalancePaymentMethodsApiResponse } from 'src/types/Balance';
import {
  getSortedPaymentMethods,
  PaymentMethodItem,
} from 'src/components/selfService/common/Balance/utils/paymentMethodUtils/getSortedPaymentMethods';

export function getCreditLimitText(creditLimit: number | null): string {
  if (!creditLimit) {
    return 'Net terms skipped';
  }

  return formatPenniesToCurrency(creditLimit);
}

export function getDisplayedPaymentMethods(
  paymentMethodsResponse: BalancePaymentMethodsApiResponse | null
): PaymentMethodItem[] {
  return getSortedPaymentMethods(paymentMethodsResponse);
}

export const WITH_CREDIT_LIMIT_TEXT =
  'Your default payment method will be charged monthly on your due date (plus a 5% fee after the 90-day free trial period)';

export const NO_CREDIT_LIMIT_TEXT =
  'Your default payment method will be charged once an order is placed, and only for the amount a person spends (plus a 5% fee after the 90-day free trial period)';

export function getPaymentMethodDescription(
  creditLimit: number | null
): string {
  return creditLimit ? WITH_CREDIT_LIMIT_TEXT : NO_CREDIT_LIMIT_TEXT;
}
